"use strict";
exports.__esModule = true;
exports.GeoPushpinChart = exports.getGeoChartDimensions = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var omit_1 = tslib_1.__importDefault(require("lodash/omit"));
var CoreGeoChart_1 = require("./core/CoreGeoChart");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_theme_provider_1 = require("@gooddata/sdk-ui-theme-provider");
var getBuckets = function (props) {
    var color = props.color, location = props.location, segmentBy = props.segmentBy, size = props.size, config = props.config;
    var buckets = [
        {
            localIdentifier: sdk_ui_1.BucketNames.SIZE,
            items: size ? [sdk_model_1.disableComputeRatio(size)] : []
        },
        {
            localIdentifier: sdk_ui_1.BucketNames.COLOR,
            items: color ? [sdk_model_1.disableComputeRatio(color)] : []
        },
        {
            localIdentifier: sdk_ui_1.BucketNames.LOCATION,
            items: location ? [location] : []
        },
        {
            localIdentifier: sdk_ui_1.BucketNames.SEGMENT,
            items: segmentBy ? [segmentBy] : []
        },
    ];
    var tooltipText = config === null || config === void 0 ? void 0 : config[sdk_ui_1.BucketNames.TOOLTIP_TEXT];
    if (tooltipText) {
        buckets.push({
            localIdentifier: sdk_ui_1.BucketNames.TOOLTIP_TEXT,
            items: [tooltipText]
        });
    }
    return buckets;
};
/**
 * @internal
 */
function getGeoChartDimensions(def) {
    var buckets = def.buckets;
    var measures = sdk_model_1.bucketsMeasures(buckets);
    var attributes = sdk_model_1.bucketsAttributes(buckets);
    var chartDimensions = [];
    if (measures.length > 0) {
        chartDimensions.push(sdk_model_1.newDimension([sdk_model_1.MeasureGroupIdentifier]));
    }
    chartDimensions.push(sdk_model_1.newDimension(attributes.map(sdk_model_1.attributeLocalId)));
    return chartDimensions;
}
exports.getGeoChartDimensions = getGeoChartDimensions;
/**
 * Specifies props that are on geo chart props but not on core chart props - these must not be passed
 * down to core chart.
 */
var NON_CORE_PROPS = [
    "backend",
    "workspace",
    "segmentBy",
    "filters",
    "sortBy",
    "location",
    "color",
    "size",
];
function GeoPushpinChartInner(props) {
    var _a;
    var backend = props.backend, workspace = props.workspace, sortBy = props.sortBy, filters = props.filters, exportTitle = props.exportTitle, _b = props.execConfig, execConfig = _b === void 0 ? {} : _b;
    var buckets = getBuckets(props);
    var newProps = omit_1["default"](props, NON_CORE_PROPS);
    var execution = (_a = backend
        .withTelemetry("GeoPushpinChart", props)
        .workspace(workspace)
        .execution()
        .forBuckets(buckets, filters))
        .withSorting.apply(_a, (sortBy || [])).withDimensions(getGeoChartDimensions)
        .withExecConfig(execConfig);
    return (react_1["default"].createElement(sdk_ui_1.IntlWrapper, { locale: props.locale },
        react_1["default"].createElement(sdk_ui_1.IntlTranslationsProvider, null, function (translationProps) {
            return (react_1["default"].createElement(CoreGeoChart_1.CoreGeoChart, tslib_1.__assign({ intl: translationProps.intl, execution: execution, exportTitle: exportTitle || "GeoPushpinChart" }, newProps)));
        })));
}
var WrappedGeoPushpinChart = sdk_ui_theme_provider_1.withTheme(sdk_ui_1.withContexts(GeoPushpinChartInner));
/**
 * @public
 */
exports.GeoPushpinChart = function (props) {
    var _a = sdk_ui_1.useResolveValuesWithPlaceholders([props.location, props.size, props.color, props.segmentBy, props.filters, props.sortBy], props.placeholdersResolutionContext), location = _a[0], size = _a[1], color = _a[2], segmentBy = _a[3], filters = _a[4], sortBy = _a[5];
    return react_1["default"].createElement(WrappedGeoPushpinChart, tslib_1.__assign({}, props, { location: location, size: size, color: color, segmentBy: segmentBy, filters: filters, sortBy: sortBy }));
};
//# sourceMappingURL=GeoPushpinChart.js.map